import Toast from '../components/pages/utils/Toast';
import { API } from '../constants/Constants';
import Instance from './interceptor';

export const addOrUpdateBillingInfo = async (id) => {
  try {
    const response = await Instance.post(
      `${API.ADD_UPDATE_BILLING_INFO}/${id}`,
    );
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const getManagers = async () => {
  try {
    const response = await Instance.get(`${API.GET_MANAGERS}`);
    if (response) {
      return response;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};
